import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

/**
 * "A new version is ready - Reload" (utils/newVersion.ts), or, for any other crash of an
 * on-demand page, "This page couldn't open - Reload". Reload is the person's choice: nothing
 * reloads by itself, so nothing unsaved is lost.
 *   layout 'panel': fills the viewer or page that could not open;
 *   layout 'bar':   a small bar under the header, over the page (nothing moves).
 */
interface Props {
  layout: 'panel' | 'bar';
  reason?: 'new-version' | 'page-error';
}

const NewVersionNotice: React.FC<Props> = ({ layout, reason = 'new-version' }) => {
  const { t } = useTranslation();
  const message = reason === 'new-version'
    ? t('app_newVersionReady', 'A new version is ready')
    : t('app_pageCouldNotOpen', "This page couldn't open");
  return (
    <div className={`dt-new-version dt-new-version--${layout}`} role="status" data-new-version={reason}>
      <span>{message} -</span>
      <button type="button" className="dt-btn sm a" onClick={() => window.location.reload()}>
        {t('app_reload', 'Reload')}
      </button>
    </div>
  );
};

export default NewVersionNotice;
